// a direct-jobs mobile driver (Employee App Access > Mobile Driver: direct jobs) is never put on a
// duty - a hard check, like "already working": the duty can't be saved for them
export const isDirectMobileDriver = (emp) => emp?.mobileOfficer?.mode === "direct" && emp?.mobileOfficer?.enabled !== false;

// The duty types a duty at this site can be: all of them at an internal site (your office - mobile
// duties are scheduled there), guarding ones anywhere else (a type with no category counts as
// guarding). The duty's own type stays listed when editing, so it never goes blank.
export const dutyTypesForSite = (types, site, currentId) => (types || []).filter((t) =>
    site?.isInternalSite === true || !t?.category || t?.category === "guarding" || (currentId && String(t?._id) === String(currentId)));

export const scheduleCheckFailureList = {

    directDriverCheck:{
        name: "directDriverCheck",
        description: "Employee is a direct-jobs mobile driver",
    },

    restPeriodCheck:{
        name: "restPeriodCheck",
        description: "Rest period of 8h is failed",
    },
    blockedSite:{
        name: "blockedSite",
        description: "Employee is blocked on this site",
    },
    skillCheck:{
        name: "skillCheck",
        description: "Employee's skills are not matched with site/area requirement",
    },
    skillExpiryCheck:{
        name:"skillExpiryCheck",
        description: "Employee's skill was expired",
    },
    visaExpiryCheck:{
        name: "visaExpiryCheck",
        description: "Employee's visa was expired."
    },
    branchCheck:{
        name: "branchCheck",
        description: "Employee is not registered with this branch.",
    },
    trainingCheck:{
        name: "trainingCheck",
        description: "Employee is not trained on this site/area"
    },
    trainingCheck:{
        name: "trainingCheck",
        description: "Employee is not trained on this site/area"
    },
    alreadyWorking: {
        name: "alreadyWorking",
        description: "Employee is already working"
    }

};